import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import MainHeader from "./components/MainHeader";
import { AuthProvider } from "./context/AuthContext";
import ChatScreen from "./screens/ChatScreen";
import LoginScreen from "./screens/LoginScreen";
import SettingScreen from "./screens/SettingScreen";
import PrivateRoute from "./components/PrivateRoute";
import { ThemeProvider } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./css/global.css";

import { Modal, Button } from "react-bootstrap";

//var globalThis = require("globalthis")();
const OutboundLinkTracker = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [eventTarget, setEventTarget] = useState('');

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target.closest('a');
      if (target && isOutboundLink(target)) {
        setShowModal(true);
        setEventTarget(target);
        event.preventDefault();
      }
    };

    document.body.addEventListener('click', handleClick);

    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);

  const isOutboundLink = (link) => {
    const hostname = window.location.hostname;
    return link.hostname !== hostname;
  };

  return <>{
    children}
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      onHide={() => {
        setShowModal(!showModal)
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px", fontWeight: '600' }}>開啟外部連結安全提示</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: '你現正開啟外部連結，請小心核實外部連結的真實性，如發覺連結不尋常，請勿打開。<br><span style="color: #ff0000;">請勿於外部網頁輸入你的任何密碼、銀行資料、戶口號碼、驗證碼或其它個人資料。</span>' }} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setShowModal(false);
          }}
        >
          再想想
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            setShowModal(false);
            window.open(eventTarget, '_blank');
          }}
        >
          確認開啟
        </Button>
      </Modal.Footer>
    </Modal></>;
};

function App() {
  const [unReadCounter, setUnReadCounter] = useState(0);

  return (
    <OutboundLinkTracker>
      <AuthProvider>
        <ThemeProvider breakpoints={["lg", "md", "sm"]}>
          <div className="chatAppRoot">
            <Routes>
              <Route
                path="/"
                exact
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          showMainScreen={true}
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/item/:listItemId"
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          showMainScreen={true}
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/:chatRoom"
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} hiddenMobile={true} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/:chatRoom/:listItemId"
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/new/:itemId"
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/new/:itemId/offer"
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <ChatScreen
                          newChat={true}
                          unReadCounter={unReadCounter}
                          setUnReadCounterHere={setUnReadCounter}
                        />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route
                path="/settings"
                exact
                element={
                  <>
                    <MainHeader unReadCounter={unReadCounter} />
                    <div className="chatAppWrap">
                      <PrivateRoute>
                        <SettingScreen />
                      </PrivateRoute>
                    </div>
                  </>
                }
              />
              <Route path="/login" element={
                <>
                  <MainHeader unReadCounter={unReadCounter} />
                  <div className="chatAppWrap"><LoginScreen /></div>
                </>
              } />
            </Routes>
          </div>
        </ThemeProvider>
      </AuthProvider>

    </OutboundLinkTracker>
  );
}

export default App;
